/** Project roles (§5.1): viewer < annotator < reviewer < manager; admins act as managers. */
import type { ProjectRole } from '@/api/types';

export const ROLE_ORDER: readonly ProjectRole[] = ['viewer', 'annotator', 'reviewer', 'manager'];

export const ROLE_LABELS: Readonly<Record<ProjectRole, string>> = {
  viewer: 'Viewer',
  annotator: 'Annotator',
  reviewer: 'Reviewer',
  manager: 'Manager',
};

/** True if `role` is at least `min` (e.g. `roleAtLeast(project.role, 'manager')`). */
export function roleAtLeast(role: ProjectRole, min: ProjectRole): boolean {
  return ROLE_ORDER.indexOf(role) >= ROLE_ORDER.indexOf(min);
}
